import { render, staticRenderFns } from "./default.vue?vue&type=template&id=25374a46&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=25374a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedMobileHeader: require('/app/components/ui/shared/MobileHeader.vue').default,UiSharedHomeHeader: require('/app/components/ui/shared/HomeHeader.vue').default,UiSharedFooter: require('/app/components/ui/shared/Footer.vue').default,UiSharedDialogsScheduleDialog: require('/app/components/ui/shared/dialogs/ScheduleDialog.vue').default,UiSharedErrorsErrorToast: require('/app/components/ui/shared/errors/ErrorToast.vue').default})
